/**
 * Certifications Module
 * Handles certifications table tab switching
 */

import { $$, on, addClass, removeClass, attr } from '../utils/dom.js';
import { closeAllDropdowns } from './dropdowns.js';

export const initCertificationsTable = () => {
  on($$(".certifications-table .company-switch-button"), "click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Find the dropdown menu and tab-content container
    // Support teleported dropdowns via _originTabContent reference
    const dropdownMenu = this.closest('.dropdown-menu');
    const tabContent = dropdownMenu._originTabContent || this.closest('.tab-content[id^="certifications-table-tab-tableContent"]');

    if (tabContent && dropdownMenu) {
      // Remove active/show from all company tabs in this tab-content
      const tabsInSection = tabContent.querySelectorAll('.company-tab');
      tabsInSection.forEach(tab => {
        removeClass(tab, "active");
        removeClass(tab, "show");
      });

      // Get target and add active to it
      const target = attr(this, "data-target");
      const targetElement = tabContent.querySelector(target);

      if (targetElement) {
        addClass(targetElement, "active");
        addClass(targetElement, "show");
      }

      // Sync active state on ALL dropdowns in this section
      const selectedName = this.textContent.trim();
      const allDropdowns = tabContent.querySelectorAll('.dropdown-menu');
      allDropdowns.forEach(menu => {
        menu.querySelectorAll('.company-switch-button').forEach(btn => {
          if (btn.textContent.trim() === selectedName) {
            addClass(btn, "active");
          } else {
            removeClass(btn, "active");
          }
        });
      });

      // Close dropdown properly (restores teleported dropdown to original position)
      closeAllDropdowns();
    }
  });
};
